export const SECONDS = 1000;
